import React, { useState } from "react";
import RechartJs from "../../components/charts/rechart";

const Statistics = () => {
  return (
    
    <>

    <div className="container pt-0">
      <div className="row mt-3">
        <div className="col-md-12">
          <RechartJs />
        </div>
      </div>
    </div>
    </>
  );
};

export default Statistics;
